<template>
  <div class="recommended-thread-teaser">
    <app-link
      :to="link"
      class="recommended-thread-teaser__image-link"
    >
      <img
        src="/common/nexus/thread-teaser-banner.png"
        alt="visit this forum thread"
        class="recommended-thread-teaser__image"
      >
    </app-link>
    <h3
      class="recommended-thread-teaser__label"
    >
      Recommended Forum
    </h3>
    <h2 class="recommended-thread-teaser__heading">
      <router-link
        :to="link"
        class="recommended-thread-teaser__heading-link link link--unstyled"
        v-html="thread.name"
      />
    </h2>
    <engagement-bar
      object-type="thread"
      :the-object="thread"
      :comment-count="thread.commentCount"
    />
  </div>
</template>

<script>
import EngagementBar from '@/components/Engagement/EngagementBar.vue';

export default {
  name: 'RecommendedThreadTeaser',
  components: {
    EngagementBar,
  },
  props: {
    thread: {
      type: Object,
      required: true,
    },
  },
  computed: {
    link() {
      return `/forums/${this.thread.slug}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_recommended-thread-teaser';
</style>
